import { BaseGetRequest } from './core/baseGetRequest';
import { SharingDataList, SharingDataListDynamicType } from 'acscp/api/models/sharingDataList';

export class SharingDataRequest extends BaseGetRequest<SharingDataList> {
    constructor(public bookingId: string) {
        super(`bookings/${bookingId}/share`, {}, SharingDataListDynamicType);
    }
}
